interface Logo {
  imageUrl: string;
  name?: string;
  link?: string;
}

interface LogoCloudProps {
  title?: string;
  subtitle?: string;
  logos?: Logo[];
}

export function LogoCloudBlock({ props }: { props: LogoCloudProps }) {
  const logos = props.logos ?? [];
  if (logos.length === 0) return null;

  return (
    <section className="py-12 px-4">
      {props.title && <h2 className="text-xl font-semibold text-center text-zinc-700 mb-2">{props.title}</h2>}
      {props.subtitle && <p className="text-sm text-zinc-500 text-center mb-8">{props.subtitle}</p>}
      <div className="flex flex-wrap items-center justify-center gap-8 max-w-4xl mx-auto">
        {logos.map((logo, i) => {
          const img = <img src={logo.imageUrl} alt={logo.name ?? ''} className="h-8 object-contain grayscale hover:grayscale-0 transition-all opacity-60 hover:opacity-100" loading="lazy" decoding="async" />;
          return logo.link ? (
            <a key={i} href={logo.link} target="_blank" rel="noopener noreferrer">{img}</a>
          ) : (
            <div key={i}>{img}</div>
          );
        })}
      </div>
    </section>
  );
}
